var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#0088cb;}.cls-4{fill:#0690c6;}.cls-5{fill:#fefefe;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "binancecoin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_51",
    "data-name": "Layer 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    className: "cls-3",
    width: 30,
    height: 30,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    className: "cls-4",
    d: "M0,7A7,7,0,0,1,7,0h6.66a16.49,16.49,0,0,1,.82,5.17A16.54,16.54,0,0,1,0,21.6Z"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M15,7h6.31a2.61,2.61,0,0,1,2.76,2.06,2.8,2.8,0,0,1-.33,2.18L17,22.8l-1.08,1.86a1,1,0,0,1-1.82,0c-2.57-4.47-5.13-9-7.72-13.43A2.92,2.92,0,0,1,5.93,9,2.62,2.62,0,0,1,8.52,7Zm1,13.55.07,0c.45-.77.9-1.55,1.36-2.32C18.92,15.62,20.47,13,22,10.34c.46-.8.12-1.4-.8-1.41H16.29C16,8.93,16,9,16,9.26Q16,14.9,16,20.55Zm-2,0,.07,0V9.28c0-.2,0-.35-.27-.35-1.71,0-3.41,0-5.11,0-.79,0-1.05.5-.67,1.17l5.37,9.36Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTon);
export default __webpack_public_path__ + "static/media/ton.4eaf88d730736e61fb5a1a0a08f33235.svg";
export { ForwardRef as ReactComponent };